import { generatePath } from 'react-router';

import { EditAction, EditStep } from '@data/models/training-course.interface';

export const getTrainingCourseUrl = (
  ref: string,
  step?: string,
  action?: EditAction,
  id?: string,
  openCommentDrawer?: boolean,
  openChat?: boolean,
): string => {
  if (!ref) return '';

  const cleanRef = ref.replace('ERPF#', '');
  const queryParams = new URLSearchParams();
  if (openCommentDrawer) queryParams.set('openCommentDrawer', '1');
  if (openChat) queryParams.set('openChat', '1');
  const query = queryParams.toString() ? `?${queryParams.toString()}` : '';

  switch (action) {
    case EditAction.ACTION:
      return generatePath('/manager/training-actions/:ref/:step', {
        ref: cleanRef,
        step: step || 'summary',
      });

    case EditAction.CONVERSION:
      return generatePath('/manager/training-actions/:ref/conversion', {
        ref: cleanRef,
      });

    case EditAction.GED:
    case EditAction.HISTORY:
      return (
        generatePath('/manager/training-course/:ref/:action?/:id?', {
          ref: cleanRef,
          action: action ?? null,
          id: id ?? null,
        }) + query
      );
  }

  const effectiveStep = step !== EditStep.CONTEXT && step ? step : 'FORM';
  return (
    generatePath('/manager/training-course/:ref/:step/:action?/:id?', {
      ref: cleanRef,
      step: effectiveStep,
      action: action ?? null,
      id: id ?? null,
    }) + query
  );
};
